import { render } from "./BtnGroup.vue?vue&type=template&id=9c9da13c&scoped=true"
import script from "./BtnGroup.vue?vue&type=script&lang=js"
export * from "./BtnGroup.vue?vue&type=script&lang=js"

import "./BtnGroup.vue?vue&type=style&index=0&id=9c9da13c&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c9da13c"]])

export default __exports__